'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exponentialBackoff = exports.constantBackoff = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = retry;

var _bluebird = require('bluebird');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var constantBackoff = exports.constantBackoff = function constantBackoff() {
  var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
  return function () {
    return amount;
  };
};
var exponentialBackoff = exports.exponentialBackoff = function exponentialBackoff() {
  var multp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return function (attempt) {
    return Math.pow(base, attempt) * multp;
  };
};

var defaultStrategy = {
  predicate: function predicate() {
    return true;
  },
  delay: constantBackoff(),
  retries: 5,
  delayer: function delayer(amountInMs) {
    return (0, _bluebird.delay)(amountInMs);
  }
};

/**
 * Run an operation with retries attached
 */
function retry(func) {
  var _this = this;

  var strategy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var attempts = 0;
  var appliedStrategy = _extends({}, defaultStrategy, strategy);
  var wrapped = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              attempts += 1;
              _context.prev = 1;
              _context.next = 4;
              return func();

            case 4:
              return _context.abrupt('return', _context.sent);

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](1);

              if (!(attempts < appliedStrategy.retries && appliedStrategy.predicate(_context.t0))) {
                _context.next = 13;
                break;
              }

              _context.next = 12;
              return appliedStrategy.delayer(appliedStrategy.delay(attempts));

            case 12:
              return _context.abrupt('return', wrapped());

            case 13:
              throw _context.t0;

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 7]]);
    }));

    return function wrapped() {
      return _ref.apply(this, arguments);
    };
  }();

  return wrapped();
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/utilities/retry.js
// module id = 35
// module chunks = 0